import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    marginTop: theme.spacing(3),
    padding: theme.spacing(2)
  },
  heading: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  title: { fontWeight: 600 },
  subtitle: {
    color: theme.palette.grey[600],
    marginTop: theme.spacing(0.5)
  },
  tableWrapper: { overflowX: 'auto' },
  effectAllow: { color: theme.palette.success.main },
  effectDeny: { color: theme.palette.error.main },
  empty: {
    color: theme.palette.grey[600],
    padding: theme.spacing(4),
    textAlign: 'center'
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4)
  },
  error: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(4)
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2)
  },
  modal: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center'
  },
  paper: {
    maxHeight: '90vh',
    maxWidth: 720,
    overflowY: 'auto',
    padding: theme.spacing(3),
    width: 'calc(100% - 32px)'
  },
  form: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: { gridTemplateColumns: '1fr' }
  },
  fullWidth: { gridColumn: '1 / -1' },
  switchRow: {
    alignItems: 'center',
    display: 'flex',
    gridColumn: '1 / -1'
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3)
  }
}))

export default useStyles
